import { FC, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { ReactComponent as ArrowDown } from '../../assets/arrow_down.svg';
import { pxToRem } from '../../utils/pxToRem';
import { colors } from '../colors';
export type IDropDown = {
  options?: Array<string>;
  value?: string;
  placeholder?: string;
  onSelect?: (item: string, index: number) => void;
};
export const DropDown: FC<IDropDown> = ({
  value,
  options,
  children,
  placeholder,
  onSelect,
  ...rest
}) => {
  const node = useRef<HTMLDivElement>(null);
  const [show, setShow] = useState(false);
  const clickOutside = (e: any) => {
    if (node.current?.contains(e.target)) return;
    setShow(false);
  };

  const handleSelect = (item: string, index: number) => {
    setShow(false);
    if (onSelect) onSelect(item, index);
  };
  useEffect(() => {
    document.addEventListener('mousedown', clickOutside);
    return () => {
      document.removeEventListener('mousedown', clickOutside);
    };
  }, [show]);
  return (
    <Container ref={node} {...rest} onClick={() => setShow(!show)}>
      <DropDownTxt
        id={'dropDownTxt'}
        isPlaceholder={value === '' && !!placeholder}
      >
        {value === '' && placeholder ? placeholder : value}
      </DropDownTxt>
      <ArrowDown />
      <DropdownContent show={show} id="content">
        {children}
        {options?.map((item, index) => (
          <DropDownItem
            key={index.toString()}
            onClick={() => handleSelect(item, index)}
          >
            {item}
          </DropDownItem>
        ))}
      </DropdownContent>
    </Container>
  );
};

const Container = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  padding: 8px 16px;
  position: relative;
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
`;
const DropDownTxt = styled.p<{ isPlaceholder?: boolean }>`
  font-family: DM Sans;
  color: ${({ isPlaceholder }) =>
    isPlaceholder ? '#a1a1a1' : colors.textDark};
  font-style: normal;
  font-weight: 500;
  font-size: ${pxToRem(14)};
  flex: 1;
`;

export const DropdownContent = styled.div<{ show: boolean }>`
  display: ${({ show }) => (show ? 'block' : 'none')};
  position: absolute;
  top: 40px;
  right: 0;
  background-color: #ffffff;
  overflow: hidden;
  min-width: 160px;
  overflow-y: auto;
  max-height: 250px;
  box-shadow: 0px 0px 1px rgba(12, 26, 75, 0.2),
    0px 1px 3px rgba(50, 50, 71, 0.1);
  border-radius: 8px;
  z-index: 10;
  & button {
    color: black;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
  }
  & button:hover {
    background-color: #f1f1f1;
  }
`;
export const DropDownItem = styled.button`
  background-color: transparent;
  border: none;
  text-align: left;
  width: 100%;
`;
